import { roleMeta } from "@/lib/screenWalkthrough";

/** Iter 47 — input / output / display / input-output pill for a screen field. */
export default function RoleBadge({ role, testid }) {
  const m = roleMeta(role);
  return (
    <span
      className="inline-flex items-center ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border whitespace-nowrap"
      style={{ background: m.bg, color: m.fg, borderColor: m.border }}
      title={m.hint}
      data-testid={testid || `role-badge-${role}`}
      data-role={role}
    >
      {m.label}
    </span>
  );
}
